module.exports = __webpack_public_path__ + "img/4.74c7beb1.png";